import { Menu } from ".";
import { Detail } from "./detail";

export class Permission {
    menu: Menu;
    details: Detail[];
}

